import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { TextField } from "@mui/material";
import { format } from "date-fns";
import { isValidDate } from "../../../utils/date";
import React from "react";

const january1st2018 = new Date("2018-01-01T00:00:00Z");

const dateFormat = "dd/MM/yyyy";

let maxDateEnd = new Date();
maxDateEnd.setDate(maxDateEnd.getDate() + 1);

// Typing into the field emits a value on every keystroke, and a half-typed year
// still parses to a real Date ("01/02/20" is year 20), so a valid Date on its own
// does not mean the user has finished. Keyboard input therefore also has to match
// the display format exactly; the calendar passes no text and needs no such check.
const onlyValidDates = (onChange) => (newValue, keyboardInput) => {
	if (!isValidDate(newValue)) return;
	if (keyboardInput !== undefined && keyboardInput !== format(newValue, dateFormat)) return;

	onChange(newValue);
};

export const StartDatePicker = (props) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<DesktopDatePicker
				label="Start Date"
				inputFormat={dateFormat}
				value={props.date}
				minDate={january1st2018}
				shouldDisableDate={(date) => date < january1st2018}
				disableFuture
				maxDate={new Date()}
				onChange={onlyValidDates(props.onChange)}
				renderInput={(params) => <TextField label="Start date" size="small" sx={{ maxWidth: 170, marginRight: "1rem", marginBottom: "1rem", ...props.sx }} {...params} />}
			/>
		</LocalizationProvider>
	);
};

export const EndDatePicker = (props) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<DesktopDatePicker
				label="End Date"
				inputFormat={dateFormat}
				value={props.date}
				minDate={january1st2018}
				shouldDisableDate={(date) => date < january1st2018}
				maxDate={maxDateEnd}
				onChange={onlyValidDates(props.onChange)}
				renderInput={(params) => <TextField label="End date" size="small" sx={{ maxWidth: 170, ...props.sx }} {...params} />}
			/>
		</LocalizationProvider>
	);
};
